import { createMuiTheme } from "@material-ui/core";

const shadows = [
  ...createMuiTheme({}).shadows.map((shadow, i) =>
    i === 1 ? "0 0 14px 0 rgba(53, 64, 82, 0.05)" : shadow
  ),
];

export default shadows;
